import dynamic from 'next/dynamic'

const Icon = dynamic(() => import('./icon'))

export default Icon
